var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackendHttpService } from '../../core/backend-http.service';
import { apiEndpoints } from '../../app.constants';
import { Observable } from 'rxjs/Observable';
import { KpiReport } from '../../../models/measure/report';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../common/common.service';
import { Router } from '@angular/router';
import { RoiReport, RoiReportKpi } from '../../../models/measure/roi-report';
import { TopicSegmentReport } from '../../../models/measure/topic-segment-report';
import { DatePipe } from '@angular/common';
import { Kpi } from '../../../models/common';
import { UserService } from '../user.service';
import { ReferenceDataService } from '../reference-data/reference-data.service';
var MeasureService = /** @class */ (function (_super) {
    __extends(MeasureService, _super);
    function MeasureService(router, translate, commonService, userService, referenceService, datePipe) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.commonService = commonService;
        _this.userService = userService;
        _this.referenceService = referenceService;
        _this.datePipe = datePipe;
        return _this;
    }
    /**
     * API to load list measure report of a company
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getListMeasureReport = function (companyId) {
        return this.get(apiEndpoints.getMeasureReportList, { selected_company_id: companyId }).map(function (res) {
            return res && res.data ? res.data.map(function (report) { return Object.assign({}, report, {
                id: report.report_id,
                name: report.report_name
            }); }) : [];
        });
    };
    /**
     * API to create or update a measure report
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.createOrUpdateReport = function (report) {
        // If and ID is assigned, the report exists and we update it
        if (report.id > 0) {
            var updateReportUrl = apiEndpoints.report + '/' + report.id;
            return this.put(updateReportUrl, report);
        }
        else {
            // If report ID is 0 it's a new report and we create it
            return this.post(apiEndpoints.report, report);
        }
    };
    /**
     * API to get ROI report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getRoiReportData = function (measureCriteria) {
        var measureData = this.buildMeasureRequestData(measureCriteria);
        var data = Object.assign({}, measureData, {
            companyId: this.userService.getCompanyId()
        });
        return Observable.forkJoin(this.getInfluencerCount(measureData), this.getTotalROI(data), this.getGlobalKpi(measureData), this.getListPostOfROI(data)).map(function (res) {
            var roiData = new RoiReport();
            var influencerData = new RoiReportKpi();
            if (res[0]) {
                influencerData.name = res[0].name;
                influencerData.value = res[0].value;
            }
            var kpiData = [];
            if (res[2]) {
                kpiData = res[2].map(function (k) { return ({
                    name: k.name,
                    value: k.value
                }); });
            }
            var totalRoiData = new RoiReportKpi();
            var currencyData = new RoiReportKpi();
            if (res[1]) {
                totalRoiData.value = res[1].totalROI;
                totalRoiData.name = 'Roi';
                currencyData.name = 'Currency';
                currencyData.value = res[1].currency ? res[1].currency : 0;
            }
            roiData.kpis = [influencerData].concat(kpiData, [totalRoiData, currencyData]);
            roiData.datas = res[3] ? res[3] : [];
            roiData.totalRow = roiData.datas.length;
            return roiData;
        });
    };
    MeasureService.prototype.getTotalROI = function (data) {
        return this.get(apiEndpoints.measureGetTotalReturnOnInvestments, data);
    };
    MeasureService.prototype.getListPostOfROI = function (data) {
        return this.get(apiEndpoints.measureGetTopReturnOnInvestments, data).map(function (res) { return res.data; });
    };
    /**
     * API to get Performance Local Area report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getPerformanceLocalAreas = function (measureCriteria) {
        var _this = this;
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetCountryReach, data).map(function (res) {
            return res.localAreas.map(function (country) {
                return Object.assign({}, country, {
                    description: _this.translate.instant('INFLUENCER.insight.platform_reach.impact', { impact: Number(country.contentPieChart.impact.value).toFixed(1) })
                });
            });
        });
    };
    /**
     * API to get Performance Timeline for measure
     * @param params
     */
    MeasureService.prototype.getPerformanceTimeline = function (params) {
        var _this = this;
        var data = this.buildMeasureRequestData(params);
        return this.get(apiEndpoints.measurePerformanceTimeline, data).map(function (res) {
            return _this.commonService.normalizeDataForActivityLineChart(res.data.data);
        });
    };
    /**
     * this method use to load Performance KPI data of ES
     * @param {number} influencerId
     * @param {number} period
     * @returns {any}
     */
    MeasureService.prototype.getPerformanceGlobalKPIsFromEs = function (params) {
        var data = this.buildMeasureRequestData(params);
        return Observable.forkJoin(this.getMentionCount(data), this.getGlobalKpi(data)).map(function (res) {
            var kpiData = new Kpi();
            kpiData.mention = res[0];
            kpiData.impressions = res[1].find(function (kpi) { return kpi.name === 'impressions'; });
            kpiData.reach = res[1].find(function (kpi) { return kpi.name === 'reach'; });
            kpiData.engagement = res[1].find(function (kpi) { return kpi.name === 'engagement'; });
            kpiData.impact = res[1].find(function (kpi) { return kpi.name === 'impact'; });
            return kpiData;
        });
    };
    MeasureService.prototype.getMentionCount = function (currentPeriod) {
        return this.get(apiEndpoints.measureGetMentionCount, currentPeriod).map(function (res) { return res.data; });
    };
    MeasureService.prototype.getGlobalKpi = function (currentPeriod) {
        return this.get(apiEndpoints.measureGetGlobalKpis, currentPeriod).map(function (res) { return res.data.KPIs; });
    };
    MeasureService.prototype.formatPercentageData = function (attributeName, lastValue, currentValue) {
        var percent;
        if (lastValue === 0) {
            percent = 0;
        }
        percent = (Math.abs(currentValue - lastValue) / lastValue) * 100;
        return {
            name: attributeName,
            value: currentValue,
            status: currentValue > lastValue ? 'asc' : 'desc',
            percent: percent
        };
    };
    /**
     * API to get Performance Mention TimeLine report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getPerformanceMentionTimeLineChart = function (measureCriteria) {
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetMentionTimeline, data);
    };
    /**
     * API to get Exposure Global KPI report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getExposureGlobalKPIs = function (measureCriteria) {
        var currentData = this.buildMeasureRequestData(measureCriteria);
        return Observable.forkJoin(this.getMentionCount(currentData), this.getPostCount(currentData), this.getInfluencerCount(currentData), this.getGlobalKpi(currentData)).map(function (res) {
            var engagmentKpi = res[3].find(function (kpi) { return kpi.name === 'engagement'; });
            var engagements = new KpiReport(engagmentKpi);
            var mentions = new KpiReport(res[0]);
            var posts = new KpiReport(res[1]);
            var influencers = new KpiReport(res[2]);
            return [
                engagements,
                mentions,
                posts,
                influencers
            ];
        });
    };
    /**
     * get post count KPI from ES
     * @param previousPeriod
     * @param currentPeriod
     * @returns {Observable<KpiItem>}
     */
    MeasureService.prototype.getPostCount = function (data) {
        return this.get(apiEndpoints.measureGetPostCount, data).map(function (res) { return res.data; });
    };
    /**
     * get influencer count KPI from ES
     * @param previousPeriod
     * @param currentPeriod
     * @returns {Observable<KpiItem>}
     */
    MeasureService.prototype.getInfluencerCount = function (data) {
        return this.get(apiEndpoints.measureGetInfluencerCount, data).map(function (res) { return res.data; });
    };
    /**
     * load Top Exposure and Best Performing Exposure report data for measure
     * @param params
     * @returns {Observable<any>}
     */
    MeasureService.prototype.getExposuresReport = function (measureCriteria) {
        var _this = this;
        var currentData = this.buildMeasureRequestData(measureCriteria);
        return Observable.forkJoin(this.get(apiEndpoints.measureGetTopExposurePosts, currentData), this.get(apiEndpoints.measureGetBestPerformingPosts, currentData)).map(function (res) { return ({
            exposures: {
                engagement: _this.normalizeExposureData(res[0].exposures.engagement),
                impact: _this.normalizeExposureData(res[0].exposures.impact),
                reach: _this.normalizeExposureData(res[0].exposures.reach),
            },
            bestPreformingExposures: {
                contents: res[1].bestPreformingExposures.contents.map(function (expo) { return Object.assign({}, expo, {
                    urlHash: expo.url_hash
                }); })
            }
        }); });
    };
    MeasureService.prototype.normalizeExposureData = function (exposureData) {
        return Object.assign({}, exposureData, {
            urlHash: exposureData.url_hash
        });
    };
    /**
     * load PlatformReach report data from ES
     * @param {MeasureSearchCriteria} measure
     * @returns {Observable<GaugeCircleChartData[]>}
     */
    MeasureService.prototype.getPlatformReachReportData = function (measureCriteria) {
        var _this = this;
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetPlatformReach, data).map(function (res) {
            return res.platforms.map(function (platform) { return Object.assign({}, platform, {
                description: _this.translate.instant('INFLUENCER.insight.platform_reach.impact', {
                    impact: Number(platform.contentPieChart.impact.value).toFixed(1)
                })
            }); });
        });
    };
    /**
     * API to get Insight Benchmark Performance report data
     * @param measureCriteria
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getInsightBenchmarkPerformance = function (measureCriteria) {
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetBenchmarkPerformance, data);
    };
    /**
     * API to get Influencer Overview report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getSegmentInfluencer = function (measureCriteria) {
        var data = this.buildMeasureRequestData(measureCriteria);
        return Observable.forkJoin(this.get(apiEndpoints.measureGetInfluencerCount, data), this.get(apiEndpoints.measureGetInfluencerOverview, data)).map(function (res) { return ({
            influencers: res[0].data,
            nationalities: res[1].nationalities,
            platforms: res[1].platforms.chartData.filter(function (ch) { return ch.value > 0; }).map(function (c) { return ({
                name: c.name,
                value: c.value
            }); })
        }); });
    };
    /**
     * API to get Interaction report data from ES
     * @param measureCriteria
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getInfluencerPostInteractionsFromES = function (measureCriteria, limit) {
        var data = this.buildMeasureRequestData(measureCriteria, true);
        var params = Object.assign({}, data, {
            pageSize: limit
        });
        return Observable.forkJoin(this.get(apiEndpoints.measureGetIntereactionPosts, params), this.get(apiEndpoints.measureGetIntereactionSummary, params)).map(function (res) { return ({
            posts: res[0].data.posts,
            totalRows: res[0].data.totalRows,
            kpi: res[1].data.kpi,
            pageNo: measureCriteria.page_no
        }); });
    };
    /**
     * API to get Insight Channel Opportunity report data
     * @param measureCriteria
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getInsightChannelOpportunity = function (measureCriteria) {
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetInsightChannelOpportunity, data);
    };
    /**
     * load all supported modules
     * @returns {Observable<any>}
     */
    MeasureService.prototype.loadListModules = function () {
        return this.get(apiEndpoints.getSections).map(function (res) {
            // transform the server-side data to client-side format data
            return res && res.data ? res.data.map(function (module) { return ({
                id: module.id,
                active_icon_link: 'assets' + module.section_active_icon_link,
                description: module.section_description,
                height: module.section_height,
                inactive_icon_link: module.section_inactive_icon_link,
                preview_image: module.section_preview_image,
                show_up: module.section_show_up,
                template: module.section_template,
                name: module.section_title,
            }); }) : [];
        });
    };
    /**
     * API to get Exposure Global KPI report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getSegmentTopics = function (measureCriteria) {
        var _this = this;
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetSegmentTopics, data).map(function (res) { return _this.transformToGaugeChartData(res.data); });
    };
    MeasureService.prototype.transformToGaugeChartData = function (rawData) {
        // prepare segment list data
        var allSegments = rawData.segments;
        var removedSegments = rawData.segmentRemoveList;
        // transform data before returing to component
        var dataCharts = allSegments.map(function (data) { return ({
            contentPieChart: {
                reach: {
                    value: data.contentPieChart.value,
                    status: data.contentPieChart.status || 'asc',
                    percent: data.contentPieChart.percent || 0
                }
            },
            name: data.name,
            progressBar: {
                name: data.name,
                value: data.valuePieChart * 100
            }
        }); });
        var topicSegmentReport = new TopicSegmentReport();
        topicSegmentReport.allTopicCharts = dataCharts;
        topicSegmentReport.removeTopics = removedSegments.map(function (segment) { return segment.name; });
        var allActiveTopicIds = this.referenceService.activeTopics.map(function (tp) { return tp.id; });
        topicSegmentReport.allTopics = allSegments.filter(function (seg) { return allActiveTopicIds.indexOf(seg.id) >= 0; }).map(function (seg) { return ({
            id: seg.id,
            name: seg.name
        }); });
        return topicSegmentReport;
    };
    /**
     * API to get Best Performing Influencers report data from ES
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.getBestPerformingInfluencersFromES = function (measureCriteria) {
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetBestPerformingInfluencers, data).map(function (res) { return ({
            data: res.data,
            total: res.totalRow
        }); });
    };
    /**
     * API to delete an existing report
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.deleteReport = function (reportId, companyId) {
        return this.delete(apiEndpoints.report + '/' + reportId, { companyId: companyId });
    };
    /**
     * API to get segment industries report data
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.loadSegmentIndutries = function (measureCriteria) {
        var data = this.buildMeasureRequestData(measureCriteria);
        return this.get(apiEndpoints.measureGetSegmentIndustries, data).map(function (res) { return res.data; });
    };
    /**
     * API to load ROI setting
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.loadRoiSetting = function (companyId) {
        return this.get(apiEndpoints.getCPM, { company_id: companyId }).map(function (res) { return res && res.data ? Object.assign({}, res.data, {
            companyId: res.data.companyID,
            calculationMethod: res.data.method
        }) : null; });
    };
    /**
     * API to update ROI setting
     * @param companyId
     * @returns {Observable<Report>}
     */
    MeasureService.prototype.saveRoiSetting = function (roiSetting) {
        var submittedRoiSetting = Object.assign({}, roiSetting, {
            company_id: roiSetting.companyId,
            method: roiSetting.calculationMethod
        });
        return this.get(apiEndpoints.setCPM, submittedRoiSetting);
    };
    MeasureService.prototype.loadOONAReportData = function (measureCriteria, limit) {
        var data = this.buildMeasureRequestData(measureCriteria, true);
        var params = Object.assign({}, data, {
            pageSize: limit
        });
        return this.get(apiEndpoints.measureGetOonaReport, params).map(function (res) { return res; });
    };
    MeasureService.prototype.exportCSV = function (projectId, influencerGroupId, fromDate, toDate) {
        return this.get(apiEndpoints.exportCSV, {
            projectId: projectId, influencerGroupId: influencerGroupId, fromDate: fromDate, toDate: toDate
        });
    };
    MeasureService.prototype.buildMeasureRequestData = function (measureCriteria, havePageNo) {
        var dateRange = measureCriteria.period;
        if (havePageNo) {
            return {
                projectId: measureCriteria.project_id || measureCriteria.campaign_id || 0,
                influencerGroupId: measureCriteria.influencerGroup,
                fromDate: dateRange.startDate,
                toDate: dateRange.endDate,
                pageNo: measureCriteria.page_no
            };
        }
        else {
            return {
                projectId: measureCriteria.project_id || measureCriteria.campaign_id || 0,
                influencerGroupId: measureCriteria.influencerGroup,
                fromDate: dateRange.startDate,
                toDate: dateRange.endDate,
                orderBy: measureCriteria.orderBy
            };
        }
    };
    return MeasureService;
}(BackendHttpService));
export { MeasureService };



// WEBPACK FOOTER //
// ./src/app/services/measure/measure.service.ts.pre-build-optimizer.js